import Icon from '../components/Icon.vue'

Icon.register({
  'dice-d6': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M422.2 109.9L256.2 9.1C236.3-3 211.7-3 191.8 9.1L25.8 109.9C20.5 113.2 20.5 121.2 25.9 124.4L224 242.6 422.1 124.4C427.5 121.2 427.5 113.2 422.2 109.9zM436 154.6L240 271.5V495.3C240 508.2 253.4 516.2 264.1 509.7L416.2 417.2C435.9 405.3 448 383.3 448 359.5V161.8C448 155.4 441.4 151.4 436 154.6zM0 161.8V359.5C0 383.3 12.1 405.3 31.8 417.2L183.9 509.7C194.6 516.2 208 508.2 208 495.3V271.5L12 154.6C6.6 151.4 0 155.4 0 161.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-d6.js
// module id = 2/qx
// module chunks = 144